export const stringToSlug = (string = '', replacer = '-') => {
    return string.toLowerCase().trimStart().replace(/ /g, replacer);
}

export const capitalizeString = (string = '') => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const truncateString = (string, length) => {
    return string.length > length ? `${string.slice(0, length)}...` : string;
}

export const stringToURL = (string = '') => {
    return string.trim().replace(/ /g, '%20');
}